export default __webpack_public_path__ + "static/649-1b6f6c485c5299d6508ab61238db3fa8.gif";